import { format } from 'date-fns'

interface BookingBannerProps {
  date: Date
  onClick?: () => void
}

export function BookingBanner({ date, onClick }: BookingBannerProps) {
  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }
    
    // Default behavior: scroll to booking message (check for both types)
    let bookingElement = document.getElementById('booking-selection-message')
    if (!bookingElement) {
      bookingElement = document.getElementById('simple-availability-message')
    }
    if (bookingElement) {
      bookingElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <div className="absolute left-1/2 -translate-x-1/2 -bottom-16 pointer-events-none z-40">
      <button 
        onClick={handleClick}
        className="max-w-full sm:max-w-sm mx-4 flex items-center gap-3 rounded-[18px] bg-green-500 text-white px-4 py-2 shadow-md pointer-events-auto cursor-pointer hover:bg-green-600 transition-colors"
      >
        <div className="text-sm leading-tight">
          <div className="font-semibold">Time Booked</div>
          <div className="text-white/90 text-xs whitespace-nowrap">{format(date, "EEE, MMM d yyyy 'at' HH:mm")}</div>
        </div>
      </button>
    </div>
  )
}


